import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input, Select } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { postBOHTransactionsCreateRequestActionCreator } from '../redux/actions/BalanceModificationTransactionsCreateActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class BalanceModificationTransactionsCreateDialog extends Component {
  constructor(props) {
    super(props);
    let desc;
    if (props.appContext.appContext === 'tray') {
      desc = 'Damaged Trays';
    } else {
      desc = props.appContext.appContext === 'bag' ? 'Damaged Bags' : 'Damaged Pallets';
    }
    this.state = {
      comments: '',
      isCommentRequired: false,
      adjustment: '',
      effectiveDateTime: props.row.row.effectiveDateTime,
      impcCode: props.row.row.impc,
      operatorCode: props.row.row.operator,
      description: desc,
    };
    this.handleAdjustment = this.handleAdjustment.bind(this);
    this.handleDescription = this.handleDescription.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.handleEffectiveDateTime = this.handleEffectiveDateTime.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
  }

  isFormValid = () => !(this.state.adjustment === '' || this.state.effectiveDateTime === 'Invalid date'
    || (this.state.isCommentRequired && this.state.comments === ''))

  handleAdjustment(e) {
    this.setState({
      adjustment: e.target.value,
    });
  }

  handleDescription(option) {
    this.setState({
      description: option.label,
      isCommentRequired: option.label === 'Other',
    });
  }

  handleComments(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  handleEffectiveDateTime(date) {
    const newDate = moment(date);
    this.setState({
      effectiveDateTime: newDate.format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  async confirmCreate() {
    await this.props.postBOHTransactionsCreateRequestActionCreator(
      this.props.appContext,
      this.state.adjustment,
      this.state.comments,
      this.state.description,
      this.state.effectiveDateTime,
      this.state.impcCode,
    );
    this.props.closeDialog();
    this.props.refreshTransactions();
  }

  render() {
    const options = [
      { label: 'Damaged Trays' },
      { label: 'New Trays' },
      { label: 'Annual adjustment' },
      { label: 'Trays found' },
      { label: 'Other' }];
    const bagOptions = [
      { label: 'Damaged Bags' },
      { label: 'New Bags' },
      { label: 'Annual adjustment' },
      { label: 'Bags found' },
      { label: 'Other' }];
    const palletOptions = [
      { label: 'Damaged Pallets' },
      { label: 'New Pallet Boxes' },
      { label: 'Annual adjustment' },
      { label: 'Pallet Boxes found' },
      { label: 'Other' }];
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Create BOH Modification Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Operator
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.operatorCode}
                    placeholder={this.state.operatorCode}
                    options={{ label: this.state.operatorCode, value: this.state.operatorCode }}
                    onChange={this.handleNewOperator}
                    isDisabled
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  IMPC
                </td>
                <td className="selected-impc">
                  <Select
                    value={this.state.impcCode}
                    placeholder={this.state.impcCode}
                    options={{ label: this.state.impcCode, value: this.state.impcCode }}
                    onChange={this.handleNewIMPC}
                    isDisabled
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Description
                </td>
                <td className="selected-impc">
                  {this.props.appContext.appContext === 'tray' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={options}
                      onChange={this.handleDescription}
                    />
                  )}
                  {this.props.appContext.appContext === 'bag' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={bagOptions}
                      onChange={this.handleDescription}
                    />
                  )}
                  {this.props.appContext.appContext === 'pallet' && (
                    <Select
                      value={this.state.description}
                      placeholder={this.state.description}
                      options={palletOptions}
                      onChange={this.handleDescription}
                    />
                  )}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">Comment</td>
                <td className="selected-impc">
                  <Input
                    value={this.state.comments}
                    onChange={this.handleComments}
                    placeholder={this.state.isCommentRequired ? 'Please enter a comment' : ''}
                    maxLength={45}
                  />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">Adjustment</td>
                <td className="selected-impc">
                  <Input type="number" value={this.state.adjustment} onChange={this.handleAdjustment} />
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Effective date & time
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.effectiveDateTime}
                        onChange={this.handleEffectiveDateTime}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmCreate}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

BalanceModificationTransactionsCreateDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  postBOHTransactionsCreateRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postBOHTransactionsCreateRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceModificationTransactionsCreateDialog);
